import React, { useState } from 'react';
import { StepResultProps } from '../types';

const StepResult: React.FC<StepResultProps> = ({
  state,
  onUpdate,
  onNext,
  onFlipAgain,
  onStartOver
}) => {
  const [continueClicked, setContinueClicked] = useState(false);

  const handleContinue = () => {
    setContinueClicked(true);
    onNext();
  };

  const chosenOption = state.chosenIndex !== null ? state.options[state.chosenIndex] : '';

  const getAIReflection = () => {
    console.log(state.aiStatus);
    console.log(state);
    if (state.aiReflection=="") {
        return <div className="reflection-loading">Thinking this through with you...</div>;
    }

    if (state.aiStatus === 'error') {
      return (
        <div className="reflection-section">
          <p>I couldn't reach your friend right now — but your gut reaction still counts.</p>
        </div>
      );
    }

    if (state.aiReflection) {
      return (
        <div className="reflection-section">
          <div dangerouslySetInnerHTML={{ __html: state.aiReflection }} />
        </div>
      );
    }

    return null;
  };

  return (
    <>
      {/* Coin Result Section */}
      <div style={{ textAlign: 'center', marginBottom: '32px' }}>
        <h2 className="step-title">It landed on...</h2>
        <div className="result-option">{chosenOption}</div>
        <p style={{ color: '#666', fontStyle: 'italic', marginTop: '16px' }}>
          Pause — what was your first reaction? Relief? Disappointment? That’s your gut talking.
        </p>
      </div>

      {/* AI Reflection Section */}
      <div>
        <h3 style={{ fontSize: '20px', marginBottom: '16px', color: '#333' }}>
          A friend's reflection
        </h3>
        {getAIReflection()}
      </div>

      {/* Disclaimer */}
      <div className="disclaimer-section">
        <p style={{ fontSize: '14px', color: '#666', textAlign: 'center', fontStyle: 'italic' }}>
          <strong>Just a friendly reminder:</strong> This is not professional advice, therapy, or counseling.
          We're just flipping a coin here to help you pause and notice your gut feelings.
          The real wisdom comes from listening to yourself and making choices that feel right for you.
          Please don't make important life decisions based solely on a coin flip!
        </p>
      </div>

      {/* Action Buttons */}
      <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', marginTop: '32px' }}>
        <button className="btn btn-secondary" onClick={onStartOver}>
          Start over
        </button>
      </div>

      {/* Continue to feedback */}
      {!continueClicked && (
        <div style={{ textAlign: 'center', marginTop: '24px' }}>
          <button className="btn" onClick={handleContinue}>
            Continue
          </button>
        </div>
      )}
    </>
  );
};

export default StepResult;
